<template>
<div class="body back-gray">
        <div class="wrap intro">
            <div class="txt-center mb-50"><img src="../../assets/images/logo.png" alt=""></div>
            <input type="number" placeholder="응시번호를 입력해 주세요" v-model="accesscode">
            <!-- <input type="text" placeholder="응시번호를 입력해 주세요" v-model="accesscode"> -->
            <div class="mt-30">
                <div class="end-list clear">
                    <div></div>
                    <p>응시번호는 시험 신청 시, 입력하신 E-mail / SMS로 발송 되었습니다.</p>
                </div>
                <div class="end-list clear">
                    <div></div>
                    <p>응시번호를 잊으신 경우 고객센터 (spac@carrotglobal.com)로 문의주시기 바랍니다.</p>
                </div>
                <div class="end-list clear">
                    <div></div>
                    <p>시작 후 응시를 끝까지 완료해주세요.</p>
                </div>
                <div class="end-list clear">
                    <div></div>
                    <p>응시 도중 앱이 중단되거나 종료를 하시면 재응시가 불가능합니다. 응시가 중단된 경우 SPAC센터로 문의해 주세요.</p>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="btn-fixed">
                <button class="btn-full" @click="doSubmit()">START</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
export default {
    name: 'Intro',
    components: {
        Footer
    },
    data: () => ({
        accesscode:""
    }),
    mounted() {
    
    },
    methods: {
        doSubmit(){
            if(this.accesscode == ""){
                alert("응시 번호를 입력해 주세요.");
                return false;
            }
            if(this.accesscode.length < 8){
                alert("응시번호는 8자 입니다.");
                return false;
            }
            if(this.accesscode.length >= 9){
                alert("응시번호는 8자 입니다.");
                return false;
            }
            var params = {
                tin_code : this.accesscode
            }
            this.axios.post(this.axios.root + "/rest/access/checkCode",params).then(res =>{
                if(res.data.err == 0){
                    if(res.data.status == "WAITING"){
                        this.$router.push('/intro_ready/'+btoa(res.data.message.sdate)+"/"+btoa(res.data.message.edate));
                    }else if(res.data.status == "COMPLETE"){
                        this.$router.push('/intro_end/'+btoa(res.data.application_date));
                    }else if(res.data.status == "EVAL_COMPLETE"){
                        this.$router.push('/intro_ev/'+btoa(res.data.email));
                    }else {
                        console.log(res.data.access_token);
                        sessionStorage.setItem("token",res.data.access_token);
                        sessionStorage.setItem("student_idx",res.data.student_idx);
                        sessionStorage.setItem("tin_code",this.accesscode);
                        this.$router.push('/setting01');
                    }
                    
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
            });
        }

    }
}
</script>